import type { ResolvedPrimaryNavigationMode } from "./primaryNavigationLayout";

export type AvatarPlacement = "sidebar" | "header" | "toolbar" | "none";

export interface AvatarPlacementContext {
  isLoginPath: boolean;
  navigationMode: ResolvedPrimaryNavigationMode;
  /** True when the sidebar (expanded or compact rail) is actually on screen. */
  sidebarVisible: boolean;
  /** False only for surfaces rendered outside the app shell (top bar absent). */
  headerVisible?: boolean;
}

/**
 * Exactly one account avatar per signed-in screen.
 * - Persistent sidebar (wide or compact rail) owns it.
 * - Otherwise the top bar owns it: this covers the overlay drawer (closed most of the
 *   time), the legacy story sidebar, a hidden sidebar and the knowledge-graph path.
 * - The story toolbar owns it only when the top bar is absent too.
 */
export const resolveAvatarPlacement = ({
  isLoginPath,
  navigationMode,
  sidebarVisible,
  headerVisible = true,
}: AvatarPlacementContext): AvatarPlacement => {
  if (isLoginPath) return "none";
  const persistentSidebar =
    sidebarVisible && (navigationMode === "wide" || navigationMode === "compact");
  if (persistentSidebar) return "sidebar";
  return headerVisible ? "header" : "toolbar";
};
